import { useEffect, useState, useRef } from "react";
import './IndividualIngredient.css'
import { FaPlus } from "react-icons/fa6";
import { get, post, put } from '../../../Services/api';
import yyyy_mm_dd_date_format from "../../../Utility/yyyy_mm_dd_date_format";
import loading_display from "../../../Utility/loading_display";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Radio, RadioGroup, InputLabel, MenuItem, Select, FormGroup, FormControlLabel, Checkbox, FormControl } from '@mui/material';

function AdminIndividualIngredient({ ingredient, setIngredient, getIngredient, user_data }) {
    const [description, setDescription] = useState('')
    const [timeToMake, setTimeToMake] = useState()
    const [timeToMakeUnit, setTimeToMakeUnit] = useState('mins')
    // Ingred
    const [ingredients, setIngredients] = useState([''])
    // Recipe
    const [recipes, setRecipes] = useState([''])
    // Course & Cuisine
    const [course, setCourse] = useState('')
    const [cuisine, setCuisine] = useState('')

    const [units, setUnits] = useState([])
    const [dietaryRestrictions, setDietaryRestrictions] = useState([])

    const [ingredientName, setIngredientName] = useState('')
    const [img, setImg] = useState()
    const [cost, setCost] = useState()
    const [calories, setCalories] = useState()
    const [carb, setCarb] = useState()
    const [fat, setFat] = useState()
    const [protein, setProtein] = useState()
    const [calcium, setCalcium] = useState()
    const [cholesterol, setCholesterol] = useState()
    const [fiber, setFiber] = useState()
    const [iron, setIron] = useState()
    const [potassium, setPotassium] = useState()
    const [saturated_fat, setSaturatedFat] = useState()
    const [sodium, setSodium] = useState()
    const [sugar, setSugar] = useState()
    const [trans_fat, setTransFat] = useState()

    useEffect(() => {
        // Initiate all values
        constructor()
    }, [ingredient])

    async function constructor() {
        try {
            setIngredientName(ingredient.name)
            setImg(ingredient.image)
            setCost(ingredient.cost)
            setCalories(ingredient.calories)
            setCarb(ingredient.carb)
            setFat(ingredient.fat)
            setProtein(ingredient.protein)
            setCalcium(ingredient.calcium)
            setCholesterol(ingredient.cholesterol)
            setFiber(ingredient.fiber)
            setIron(ingredient.iron)
            setPotassium(ingredient.potassium)
            setSaturatedFat(ingredient.saturated_fat)
            setSodium(ingredient.sodium)
            setSugar(ingredient.sugar)
            setTransFat(ingredient.trans_fat)

            // Get units
            await getIngredientUnits()
            // Get dietary restrictions
            await getDietaryRestrictions()
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    async function getIngredientUnits() {
        try {
            const tmp = []
            const result = await get('/api/ingredients/get-all-ingredient-units')
            result.map((res, i) => {
                if (res.unit_id == ingredient.unit_id)
                    tmp.push({ ...res, selected: true })
                else
                    tmp.push({ ...res, selected: false })
            })
            setUnits(tmp)
        } catch (error) {
            console.log(error)
        }
    }

    async function getDietaryRestrictions() {
        try {
            const tmp = []
            const result = await get('/api/admin/ingredient/get-dietary-restrictions')
            result.map((res, i) => {
                if (ingredient?.restriction_ids?.includes(res.id))
                    tmp.push({ ...res, selected: true })
                else
                    tmp.push({ ...res, selected: false })
            })
            setDietaryRestrictions(tmp)
        } catch (error) {
            console.log(error)
        }
    }

    async function generateImage() {
        loading_display(true)
        // generate image
        const result = await get('/api/admin/ingredient/generate-ingredients-image?ingredient_name=' + ingredient.name + '&ingredient_id=' + ingredient.ingredient_id)
        loading_display(false)
        // get ingredient detail again
        getIngredient(ingredient.ingredient_id)
    }

    async function generateCost() {
        loading_display(true)
        // generate cost
        const result = await post('/api/admin/ingredient/generate-ingredients-cost', {
            ingredient_id_array: [ingredient.ingredient_id],
            currency_code: 'USD',
            country_code: 'US'
        })
        loading_display(false)
        // get ingredient detail again
        getIngredient(ingredient.ingredient_id)
    }

    async function generateNutritionInfo() {
        loading_display(true)
        // generate nutrition info
        const result = await post('/api/admin/ingredient/regenerate-ingredient-detail', {
            ingredient_id_array: [ingredient.ingredient_id]
        })
        loading_display(false)
        // get ingredient detail again
        getIngredient(ingredient.ingredient_id)
    }


    async function saveChanges(e) {
        loading_display(true)
        const unit_tmp = units.find(unit => unit.selected)?.unit_id || ingredient.unit_id;
        const restriction_tmp = dietaryRestrictions
            .filter(restriction => restriction.selected) // Keep only selected elements
            .map(restriction => restriction.id);

        // add data to ingredient
        const ingredient_data = {
            ingredient_name: ingredientName,
            cost: cost,
            country_code: 'US',
            currency_code: 'USD',
            calories: calories,
            carb: carb,
            fat: fat,
            protein: protein,
            calcium: calcium,
            cholesterol: cholesterol,
            fiber: fiber,
            iron: iron,
            potassium: potassium,
            saturated_fat: saturated_fat,
            sodium: sodium,
            sugar: sugar,
            trans_fat: trans_fat,
            restriction_ids: restriction_tmp,
            unit: unit_tmp
        }

        try {
            const result = await put("/api/admin/ingredient/update-ingredient", {
                ingredient_detail: ingredient_data,
                ingredient_id: ingredient.ingredient_id,
            })
            if (!result) {
                alert('Error saving changes')
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        await getIngredient(ingredient.ingredient_id)

        loading_display(false)
    }

    async function deleteIngredient() {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            try {
                // set subscriber status
                const result = await post('/api/admin/ingredient/delete-ingredient', {
                    ingredient_id_array: [ingredient.ingredient_id]
                })

                if (result.message == "success")
                    setIngredient() // close detail panel
                else if (result.ingredients) alert('Error deleting ingredient. These ingredients are in use: ' + result.ingredients)
                else alert('Error deleting ingredient')
            } catch (error) {
                console.log(error)
                alert('Error deleting ingredient. Most likely it is in use by a user.')
            }

            loading_display(false)
        }
    }



    return (
        <div className='admin_ingredients_indiv_ingredient'>
            <div className="flex flex_column gap_20">
                <div className="flex gap_12">
                    <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateCost()}>Regenerate Cost</button>
                    <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateNutritionInfo()}>Regenerate Nutrition Detail</button>
                    <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateImage()}>Generate Image</button>
                    <p className='admin_ingredients_indiv_filter_attention_selected' onClick={() => deleteIngredient()}>Delete Ingredient</p>
                </div>
            </div>


            <div className="create_meal_modal_action_buttons flex gap_6">
                <p className="create_meal_modal_action_cancel font_weight_600 cursor_pointer" onClick={() => setIngredient()}>Cancel</p>
                <button onClick={saveChanges} className=" create_meal_modal_action_create_meal green_gradient white font_weight_600 cursor_pointer font_size_14">Save Changes</button>
            </div>

            <div className="flex flex_column gap_40">
                <div className="create_meal_modal_general_detail">
                    <div className="create_meal_modal_left_right_div flex flex_column gap_16 ">
                        <div>
                            <p className="font_size_20">Ingredient Name*</p>
                            <input className="create_meal_modal_meal_name" placeholder="Name of ingredient..." value={ingredientName} onChange={(e) => setIngredientName(e.target.value)} required />
                        </div>

                        <div className="flex flex_column gap_20">
                            <div>
                                <p className='font_size_18 word_break'>Unit</p>
                                <select className="create_meal_modal_meal_unit"
                                    onChange={(e) => setUnits(units.map(unit => ({
                                        ...unit,
                                        selected: unit.unit_id == e.target.value
                                    })))
                                    }>
                                    {units?.map((unit, i) => (
                                        <option value={unit.unit_id} key={i} selected={unit.selected}>{unit.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex gap_8 flex_column">
                                <p className='font_size_16'>Cost</p>
                                <div className="flex gap_6 align_center">
                                    <p>$</p>
                                    <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={cost ? cost : ''} onChange={(e) => {
                                        let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                                        if (amount <= 0)
                                            amount = 0
                                        else if (amount > 9999)
                                            amount = 999
                                        setCost(amount)
                                    }} required />
                                </div>
                            </div>

                            <div>
                                <p className='font_size_18 word_break'>Dietary Restrictions</p>
                                <FormControl component="fieldset">
                                    <FormGroup>
                                        {dietaryRestrictions?.map((unit, i) => (
                                            <FormControlLabel
                                                className='gray_scale_1'
                                                key={unit.name} // Ensure a unique key is provided
                                                control={
                                                    <Checkbox
                                                        value={unit.id}
                                                        checked={unit.selected}
                                                        onChange={(e) => setDietaryRestrictions(prevRestrictions =>
                                                            prevRestrictions.map(restriction =>
                                                                restriction.id == unit.id
                                                                    ? { ...restriction, selected: !restriction.selected } // Toggle selected
                                                                    : restriction
                                                            )
                                                        )}
                                                        name={unit.text}
                                                        sx={{
                                                            // Customize the checkbox color
                                                            '& .MuiSvgIcon-root': {
                                                                color: '#82BD9C', // Default color
                                                                '&.Mui-checked': {
                                                                    color: '#299257', // Color when checked
                                                                },
                                                            },
                                                        }}
                                                    />
                                                }
                                                label={unit.text}
                                            />
                                        ))}
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                    </div>

                    <div className="create_meal_modal_left_right_div create_meal_modal_image_div flex align_center justify_center">
                        {img ?
                            <img className="create_meal_modal_img" src={typeof img === "string" ? img : URL.createObjectURL(img)} />
                            : <div className="flex flex_column gap_20 align_center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
                                    <path d="M50.6254 36.125C50.3431 39.8794 48.6593 43.3903 45.9083 45.9607C43.1573 48.5311 39.5402 49.9729 35.7754 50H15.0254C12.3949 49.9973 9.81144 49.3029 7.53409 47.9865C5.25673 46.6702 3.36559 44.778 2.05037 42.5L11.2254 35C12.3411 34.0868 13.7442 33.5984 15.1857 33.6212C16.6273 33.6441 18.0142 34.1769 19.1004 35.125C19.829 35.8016 20.6849 36.3266 21.6183 36.6694C22.5517 37.0122 23.5439 37.166 24.5373 37.1218C25.5306 37.0776 26.5053 36.8363 27.4046 36.4119C28.3038 35.9876 29.1097 35.3887 29.7754 34.65L34.7754 29.2C35.3284 28.5928 35.9993 28.1045 36.7472 27.7649C37.495 27.4254 38.3042 27.2417 39.1254 27.225C39.9477 27.1999 40.7661 27.3471 41.5282 27.6571C42.2902 27.9671 42.979 28.433 43.5504 29.025L50.6254 36.125ZM50.6254 15.025V30.8L46.1754 26.35C45.2612 25.4218 44.1715 24.6847 42.9698 24.1815C41.768 23.6784 40.4782 23.4192 39.1754 23.4192C37.8725 23.4192 36.5827 23.6784 35.381 24.1815C34.1792 24.6847 33.0896 25.4218 32.1754 26.35L31.9254 26.625L26.9254 32.075C26.2334 32.8268 25.2725 33.2748 24.2518 33.3217C23.2311 33.3685 22.2333 33.0103 21.4754 32.325C19.7566 30.8242 17.5691 29.9685 15.2882 29.9046C13.0074 29.8408 10.7754 30.5728 8.97537 31.975L0.500368 38.6C0.260617 37.4159 0.168249 36.2067 0.225368 35V15C0.225018 11.0562 1.77789 7.27085 4.54782 4.46349C7.31776 1.65612 11.0819 0.0525845 15.0254 0H35.8004C39.7482 0.0460613 43.5187 1.64673 46.294 4.45479C49.0693 7.26286 50.6256 11.0519 50.6254 15V15.025ZM19.7754 15.275C19.7754 14.2861 19.4821 13.3194 18.9327 12.4971C18.3833 11.6749 17.6024 11.034 16.6888 10.6556C15.7752 10.2772 14.7698 10.1781 13.7999 10.3711C12.83 10.564 11.9391 11.0402 11.2398 11.7395C10.5406 12.4387 10.0644 13.3296 9.87144 14.2995C9.67852 15.2695 9.77753 16.2748 10.156 17.1884C10.5344 18.102 11.1753 18.8829 11.9975 19.4324C12.8198 19.9818 13.7865 20.275 14.7754 20.275C16.1014 20.275 17.3732 19.7482 18.3109 18.8105C19.2486 17.8729 19.7754 16.6011 19.7754 15.275Z" fill="#C5C1B9" />
                                </svg>
                                <p className="gray_scale_3 font_size_20 font_weight_600">Upload Photo</p>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div className="admin_ingredients_indiv_detail_list_div">
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Cal</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={calories ? calories : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setCalories(amount)
                        }} required />
                        <p>kCal</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Carb</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={carb ? carb : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setCarb(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Fat</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={fat ? fat : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setFat(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Protein</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={protein ? protein : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setProtein(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Calcium</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={calcium ? calcium : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setCalcium(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Cholesterol</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={cholesterol ? cholesterol : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setCalories(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Fiber</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={fiber ? fiber : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setFiber(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Iron</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={iron ? iron : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setIron(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Potassium</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={potassium ? potassium : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setPotassium(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Saturated Fat</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={saturated_fat ? saturated_fat : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setSaturatedFat(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Sodium</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={sodium ? sodium : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setSodium(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Sugar</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={sugar ? sugar : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setSugar(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
                <div className="flex gap_8 flex_column">
                    <p className='font_size_16'>Trans Fat</p>
                    <div className="flex gap_6 align_center">
                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="0.00" type="number" value={trans_fat ? trans_fat : ''} onChange={(e) => {
                            let amount = Math.round(parseFloat(e.target.value) * 100) / 100
                            if (amount <= 0)
                                amount = 0
                            else if (amount > 9999)
                                amount = 999
                            setTransFat(amount)
                        }} required />
                        <p>gram</p>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AdminIndividualIngredient;